<kl-header (onShowSidebar)="showSidebar = true"></kl-header>
<kl-sidebar
  [showSidebar]="showSidebar"
  (onHideSidebar)="showSidebar = false"
></kl-sidebar>
<kl-loading></kl-loading>
<main>
  <div class="grid">
    <kl-menu *ngIf="showMenu" [userRole]="userRole"></kl-menu>
    <aside *ngIf="!showMenu">
      <div class="brand">
        <img src="assets/img/preloader/preloader.full.png" alt="preloader" />
      </div>
    </aside>
    <my-tabs>
      <my-tab [title]="'overview' | translate" tabId="dashboard_001"></my-tab>
    </my-tabs>
    <div class="clearfix"></div>
  </div>
  <kl-panel></kl-panel>
</main>
<kl-modal></kl-modal>
